import { useState } from 'react';
import { cn } from '@shared/lib/cn';
import { Button } from './button';

export function CopyField({
  label,
  value,
  className,
  mono = true,
}: {
  label: string;
  value: string;
  className?: string;
  mono?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable — silently ignore */
    }
  };

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="flex-1 space-y-0.5">
        <div className="text-[10px] uppercase tracking-wide text-muted-foreground">{label}</div>
        <div className={cn('truncate text-sm', mono && 'font-mono')}>{value}</div>
      </div>
      <Button size="sm" variant="outline" onClick={copy}>
        {copied ? '✓' : '📋'}
      </Button>
    </div>
  );
}
